const isEmail = (email: string): boolean => {
  const emailPattern = "[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+";
  return email.match(emailPattern) != null;
};

export { isEmail };
